import { CustomCellEditorProps } from 'ag-grid-react';
import AutocompleteSelection from 'DesignSystem/Inputs/AutocompleteSelection/AutocompleteSelection';
import React, { FC, useState } from 'react';
import { LandOwnershipLabels } from 'FeatureModules/Site/utils/site.utils';

const LandOwnershipCellEditor: FC<CustomCellEditorProps<unknown, string>> = ({
  value,
  onValueChange,
  stopEditing,
}) => {
  const landownershipOptions = Object.entries(LandOwnershipLabels).map(([key, label]) => ({
    id: key,
    title: label,
  }));

  const initialSelection = landownershipOptions.find(option => option.title === value)?.id;

  const [selection, setSelection] = useState<string | string[] | undefined>(initialSelection);

  const getLabel = (selection: string | string[]) =>
    landownershipOptions.find(option => option.id === selection)?.title;

  const handleRawMaterialSelect = (newSelection: string[] | string | undefined) => {
    setSelection(() => newSelection);
    onValueChange(newSelection ? getLabel(newSelection) : '');
    stopEditing();
  };

  return (
    <AutocompleteSelection
      label="Select land ownership"
      defaultOpen
      enableAddNewItem
      size="small"
      multiple={false}
      items={landownershipOptions}
      errorMessage={'error'}
      hasError={false}
      selected={selection || ''}
      maxWidth={150}
      onSelectionChange={handleRawMaterialSelect}
    />
  );
};

export default LandOwnershipCellEditor;
